const FilterOperatorDisplay = (props) => {
    switch (props.operatorName) {
        case "LESS_THAN":
            return "is less than";
        case "LESS_THAN_OR_EQUAL":
            return "is less than or equal to";
        case "GREATER_THAN_OR_EQUAL":
            return "is greater than or equal to";
        case "GREATER_THAN":
            return "is greater than";
        case "EQUAL":
            return "is";
        case "IN":
            return "is one of";
        case "ILIKE":
            return "contains";
        case "LIKE":
            return "contains (case-sensitive)";
        case "NOT_IN":
            return "is not one of";
        case "LAST_YEAR":
            return "is last year";
        case "LAST_QUARTER":
            return "is last quarter";
        case "LAST_MONTH":
            return "is last month";
        case "LAST_WEEK":
            return "is last week";
        case "YESTERDAY":
            return "is yesterday";
        case "TODAY":
            return "is today";
        case "THIS_WEEK":
            return "is this week";
        case "THIS_MONTH":
            return "is this month";
        case "THIS_QUARTER":
            return "is this quarter";
        case "THIS_YEAR":
            return "is this year";
        case "TOMORROW":
            return "is tomorrow";
        case "NEXT_WEEK":
            return "is next week";
        case "NEXT_MONTH":
            return "is next month";
        case "NEXT_QUARTER":
            return "is next quarter";
        case "NEXT_YEAR":
            return "is next year";
        case "ALL":
            return "is all of";
        case "NOT_ALL":
            return "is not all of";
        default:
            return props.operatorName;
    }
};
export default FilterOperatorDisplay;
